module.exports = __webpack_public_path__ + "img/manda_020.0e4765b5.png";